module.exports = __webpack_public_path__ + "static/media/studio-step1.c3e9fa36.png";